import { get } from 'lodash'

export function getOauthProvider(state, provider) {
  return get(state, `oauth.${provider}`, {})
}

export function getOauthUserData(
  state,
  provider,
  workspaceId,
  sourceSlug,
  integrationSlug
) {
  return (getOauthUserRequest(
    state,
    provider,
    workspaceId,
    sourceSlug,
    integrationSlug
  ) || {}
  ).data
}

export function getOauthUserRequest(
  state,
  provider,
  workspaceId,
  sourceSlug,
  integrationSlug
) {
  let oauthKey = `${workspaceId}-${sourceSlug}-${provider}-userdata`
  if (integrationSlug)
    oauthKey = `${workspaceId}-${sourceSlug}-${integrationSlug}-${provider}-userdata`
  return get(state, `oauth.${oauthKey}`)
}

export function getOauthLocalStorageFlags(state) {
  return get(state, 'oauth.localStorageFlags', {})
}
